const darkSelectStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: '#232636',
    borderColor: state.isFocused ? '#6C63FF' : '#2E3247',
    color: '#F1F5F9',
    boxShadow: state.isFocused ? '0 0 0 1px #6C63FF' : 'none',
    '&:hover': {
      borderColor: '#6C63FF',
    },
    minHeight: 40,
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: '#232636',
    border: '1px solid #2E3247',
    zIndex: 9999,
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  menuList: (base) => ({
    ...base,
    backgroundColor: '#232636',
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? '#6C63FF'
      : state.isFocused
      ? '#2A2D3E'
      : '#232636',
    color: '#F1F5F9',
    borderBottom: '1px solid rgba(255, 255, 255, 0.15)',
    '&:active': {
      backgroundColor: '#6C63FF',
    },
  }),
  singleValue: (base) => ({
    ...base,
    color: '#F1F5F9',
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: '#2A2D3E',
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: '#F1F5F9',
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: '#94A3B8',
    '&:hover': {
      backgroundColor: '#EF4444',
      color: '#FFFFFF',
    },
  }),
  placeholder: (base) => ({
    ...base,
    color: '#94A3B8',
  }),
  input: (base) => ({
    ...base,
    color: '#F1F5F9',
  }),
  indicatorSeparator: (base) => ({
    ...base,
    backgroundColor: '#2E3247',
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: '#94A3B8',
    '&:hover': {
      color: '#F1F5F9',
    },
  }),
  clearIndicator: (base) => ({
    ...base,
    color: '#94A3B8',
    '&:hover': {
      color: '#EF4444',
    },
  }),
  noOptionsMessage: (base) => ({
    ...base,
    color: '#94A3B8',
  }),
};

export default darkSelectStyles;
